import React, {useEffect, useState} from "react";
import {
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Grid, IconButton, makeStyles,
    Typography
} from "@material-ui/core";
import Controls from "../../components/controls/Controls";
import Webcam from "react-webcam";
import {Camera} from "@material-ui/icons";
import {Alert, AlertTitle} from "@material-ui/lab";
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';

const useStyles = makeStyles((theme) => ({
    previewImage: {
        verticalAlign: 'center'
    },
    cameraPreviewContainer: {
        padding: '10px',
        display: "flex",
        flexDirection: 'column',
        alignItems: "inherit",
        border: '1px solid grey',
        height: '100%',
        justifyContent: 'space-between',
        position: "relative"
    },
    imageLabel: {
        textTransform: 'uppercase',
        fontSize: '0.875rem',
        fontWeight: 'bold',
        margin: '4px',
        padding: '5px 15px',
        textAlign: 'center'
    },
    swapCameraButton: {
        position: "absolute",
        top: theme.spacing(2),
        right: theme.spacing(2)
    }

}))

export default function CameraDialog(props) {
    const {open, handleClose, handleLineImageCapture, recordNumber, lineImage} = props;
    const webCamRef = React.useRef(null);
    const [cameraConnectSuccessful, setCameraConnectSuccessful] = useState(true);
    const [videoConstraint, setVideoConstraint] = useState({
        facingMode: 'user'
    });
    const [numberOfAvailableDevices, setNumberOfAvailableDevices] = useState(1);

    useEffect(() => {
       checkNumberOfCamera();

    }, []);

    function checkNumberOfCamera(){
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            console.log("This browser does not support the API yet");

            return;
        }
        navigator.mediaDevices.enumerateDevices()
            .then(function(devices) {
                let count = 0;
                devices.forEach(function(mediaDevice) {
                    if (mediaDevice.kind === 'videoinput') {
                        count ++;
                    }
                });
                setNumberOfAvailableDevices(count);
            })
            .catch(function (err) {
                //console.log(err.name + ": " + err.message);
            });
    }

    const handleCaptureImage = () => {
        const image = webCamRef.current.getScreenshot();
        handleLineImageCapture(recordNumber, image);
    }

    const handleImageDialogClose = () => {
        handleClose();
    }

    const handleCameraAccessError = () => {
        setCameraConnectSuccessful(false)
    }

    const handleCameraAccessSuccess = () => {
        setCameraConnectSuccessful(true)
        checkNumberOfCamera();
    }

    const handleCameraSwap = (e) => {
        e.preventDefault();
        let facingMode = videoConstraint.facingMode;
        facingMode = facingMode === 'user' ? 'environment' : 'user';
        setVideoConstraint({
            ...videoConstraint,
            facingMode: facingMode
        })
        console.log('Changing mode to ' + facingMode)
    }

    const classes = useStyles();
    return (
        <Dialog open={open} onClose={handleClose}
                maxWidth='lg'
                fullWidth={true}
                aria-labelledby="camera-dialog-title">
            <DialogTitle id="camera-dialog-title">Capture Picture</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Container className={classes.cameraPreviewContainer}>
                            <Webcam
                                audio={false}
                                ref={webCamRef}
                                screenshotFormat='image/jpeg'
                                onUserMediaError={handleCameraAccessError}
                                onUserMedia={handleCameraAccessSuccess}
                                videoConstraints={videoConstraint}
                            />
                            {cameraConnectSuccessful ? <div>
                                    <Typography color='textSecondary' className={classes.imageLabel}>
                                        Camera preview
                                    </Typography>
                                </div> :
                                <div>

                                    <Alert severity="error">
                                        <AlertTitle>Cannot access camera</AlertTitle>
                                        Please verify that you setup camera correctly and granted permission to access
                                        camera
                                    </Alert>
                                </div>}

                        </Container>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {
                            lineImage ? (
                                <Container className={classes.cameraPreviewContainer}>
                                    <img
                                        className={classes.previewImage}
                                        src={lineImage} alt='Preview'/>
                                    <Typography color='textSecondary' className={classes.imageLabel}>
                                        Your Capture
                                    </Typography>
                                </Container>
                            ) : null
                        }
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>

                <Controls.Button text="Close" onClick={handleImageDialogClose} color='default'/>
                <Controls.Button
                    variant='outlined'
                    color='primary'
                    text='Capture Image'
                    onClick={handleCaptureImage}
                    endIcon={<Camera/>}
                    disabled={!cameraConnectSuccessful}
                />

                {
                    numberOfAvailableDevices > 1 ? <IconButton
                        color='primary'
                        onClick={handleCameraSwap}
                        disabled={!cameraConnectSuccessful}>
                        <FlipCameraAndroidIcon/>
                    </IconButton> : null
                }
            </DialogActions>
        </Dialog>);
}
